// Enum used in all levels to distinguish types of address.
export const AddressType = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
};
